<ng-container *transloco="let t;">
    <div class="col-xl-12 col-md-12 col-12 py-75 px-25 border-bottom">
        <div class="custom-control custom-switch mb-0">
            <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center">
                    <span placement="auto" triggers="hover" class="me-50 pb-25">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                            stroke="#6e6b7b" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M9 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                            <path d="M9 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                            <path d="M9 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                            <path d="M15 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                            <path d="M15 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                            <path d="M15 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                        </svg>
                    </span>
                    <label class="label-text mb-0">
                        {{ box.name | titlecase }}
                    </label>
                </div>

                <div class="d-flex me-1 align-items-center">
                    <div class="overviewFieldIcon me-2" ngbTooltip="Tooltip text here">
                        <i data-feather="info" class="font-medium-1 cursor-pointer"></i>
                    </div>
                    <div class="overviewFieldIcon">
                        <span class="cursor-pointer">
                            @if (box.is_locked) {
                                <app-lock-icon-svg></app-lock-icon-svg>
                            } @else if(box.status === true) {
                                <app-eye-icon-svg (click)="updateBoxStatus(false)"></app-eye-icon-svg>
                            } @else if(box.status === false) {
                                <app-eye-close-icon-svg (click)="updateBoxStatus(true)"></app-eye-close-icon-svg>
                            } 
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>